import '../App.css';
import React, { useEffect } from 'react'

export default function Footer() {

    return (
        <footer className="footer text-center py-3">
            <div className="container">
                <div className="row">
                    <div className="col-md-6 offset-md-3">
                        <p>Contact: rafaelvazevedo9@gmail.com</p>
                        <p>&copy; 2026 Rafael Azevedo. All rights reserved.</p>
                    </div>
                </div>
            </div>
        </footer>
    )
}